import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const keypadButtonStyles = makeStyles(theme => ({
  keypadButton: {
    border: `1px solid ${themeColor.secondaryLight}`,
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    borderRadius: 2,
    height: '7.29vh',
    fontSize: vh(1.82),
    fontWeight: 500,
    color: theme.palette.info.dark,
    lineHeight: 1.29,
    '@media (max-width: 1366px)': {
      fontSize: vh(1.56),
    },
  },
}));
